enum AccessReportsAccessAnalysisElementEnum {
  CalculationMethod = "calculationMethod",
  DistanceMethod = "distanceMethod",
  AccessStandard = "standard",
}

export { AccessReportsAccessAnalysisElementEnum };
